import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useT } from '../i18n/i18n';

export const SCHOOL_KEEP_KEY = 'el.school.keep';

export default function SsoCallbackPage() {
  const t = useT();
  const nav = useNavigate();
  const { loginWithSchool } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const q = new URLSearchParams(window.location.search);
    const code = q.get('code');
    const state = q.get('state');
    let keep = false;
    try { keep = sessionStorage.getItem(SCHOOL_KEEP_KEY) === '1'; sessionStorage.removeItem(SCHOOL_KEEP_KEY); } catch { /* storage off */ }
    window.history.replaceState(null, '', '/sso/callback');
    if (!code || !state) {
      setError(t('That sign-in did not finish. Please sign in again.'));
      return;
    }
    loginWithSchool(code, state, keep)
      .then(() => nav('/', { replace: true }))
      .catch((e) => setError(e instanceof Error ? e.message : t('Sign-in failed')));
  }, [loginWithSchool, nav, t]);

  return (
    <section style={{ maxWidth: 460, margin: '0 auto' }}>
      <div className="card">
        {error ? (
          <>
            <h2>{t('Sign-in did not finish')}</h2>
            <div className="error" role="alert">{error}</div>
            <div className="toolbar"><Link className="btn" to="/login">{t('Back to sign in')}</Link></div>
          </>
        ) : (
          <p className="muted" role="status">{t('Signing you in…')}</p>
        )}
      </div>
    </section>
  );
}
